import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { Form } from 'src/reducers/forms';
import { updateFormDirtyState as updateFormDirtyStateAction } from 'src/reducers/forms/actionCreators';

interface Props {
  form: Form;
  dirty?: boolean;
}

export const useFormDirtyStateUpdates = ({ form, dirty }: Props) => {
  const dispatch = useDispatch();

  const updateFormDirtyState = useCallback(
    ({ dirty: currDirty }: { dirty: boolean }) => {
      dispatch(
        updateFormDirtyStateAction({
          form,
          dirty: currDirty,
        }),
      );
    },
    [dispatch, form],
  );

  useEffect(() => {
    if (typeof dirty !== 'undefined') {
      dispatch(
        updateFormDirtyStateAction({
          dirty,
          form,
        }),
      );
    }

    return () => {
      dispatch(
        updateFormDirtyStateAction({
          dirty: false,
          form,
        }),
      );
    };
  }, [dispatch, form, dirty]);

  return updateFormDirtyState;
};
